import React, { useContext } from 'react';
import { correctOrphanWordInSentence } from '../../utils/textHelpers';
import { dispatchWorkflowCompleteEvent, redirectToExternalURL } from '../../utils/externalEvents';
import Text, { getText } from '../../components/Text';
import { EmbeddableConfigContext } from '../../config/EmbeddableContext';

import './ThankYou.scss';

export default function ThankYou(props) {
  const embeddedContext = useContext(EmbeddableConfigContext);

  const {
    location: {
      state: {
        skipped,
        scoringRequest: {
          trustStartPublicConfig: {
            bankingRedirect = false,
          } = {},
        } = {},
      } = {},
    } = {},
  } = props;

  if (bankingRedirect?.enabled && bankingRedirect.redirectUrl) {
    window.location.href = bankingRedirect.redirectUrl;
  }

  const { enabledFeatures, clientRedirectURL } = embeddedContext;
  const isRedirectedFromStandalone = enabledFeatures && enabledFeatures.tswebEnabled;

  if (isRedirectedFromStandalone) {
    if (!clientRedirectURL) dispatchWorkflowCompleteEvent(skipped);
    else redirectToExternalURL(clientRedirectURL);
  }

  const renderRedirectMessage = () => {
    if (!clientRedirectURL) return null;

    return (
      <p>
        <Text value="Please wait while we are redirecting you to the next step" />
      </p>
    );
  };

  return (
    <div className="thank-you-screen">
      <h2><Text value="Thank You" /></h2>
      <p>
        {correctOrphanWordInSentence(getText('Information Received'))}
      </p>
      <img
        alt={getText('Thank You')}
        className="thank-you-graphic"
        src="/images/img-thankyou.png"
        srcSet="/images/img-thankyou@2x.png 2x, /images/img-thankyou@2x.png 3x"
      />
      { renderRedirectMessage() }
    </div>
  );
}
